function PromotionsComponent($http, AppConstants) {
	'ngInject';

	const service = {
		addComponent: addComponent,
		removeComponent: removeComponent,
		fetchPromotion: fetchPromotion,
		fetchPromotions: fetchPromotions,
		getPromotions: getPromotions,
		getPromotion: getPromotion,
		getPaginationInfo: getPaginationInfo,
		createPromotion: createPromotion,
		updatePromotion: updatePromotion,
		deletePromotion: deletePromotion
	};

	let promotions = [];
	let promotion = {};
	const paginationInfo = {};

	return service;

	function fetchPromotions(page = 1, sort = '-id') {
		return $http.get(`${AppConstants.apiUrl}/promotions`, {
			'params': {
				page,
				sort,
				'per_page': AppConstants.perPage
			}
		})
			.then(setPromotions)
			.catch(failedRequest);
	}

	function fetchPromotion(id, relations = 'translations') {
		return $http.get(`${AppConstants.apiUrl}/promotions/${id}`, {
			'params': {
				'with': relations
			}
		})
			.then(setPromotion)
			.catch(failedRequest);
	}

	function setPromotions(response) {
		paginationInfo.page_size = AppConstants.perPage;
		paginationInfo.page = response.data.current_page;
		paginationInfo.total = response.data.total;
		promotions = response.data.data;

		return promotions;
	}

	function setPromotion(response) {
		promotion = response.data.data;

		return promotion;
	}

	function getPromotions() {
		return promotions;
	}

	function getPromotion() {
		return promotion;
	}

	function getPaginationInfo() {
		return paginationInfo;
	}

	function createPromotion(params) {
		return $http.post(`${AppConstants.apiUrl}/promotions`, params)
			.then(successRequest)
			.catch(failedRequest);
	}

	function updatePromotion(id, params) {
		return $http.put(`${AppConstants.apiUrl}/promotions/${id}`, params)
			.then(successRequest)
			.catch(failedRequest);
	}

	function deletePromotion(id) {
		return $http.delete(`${AppConstants.apiUrl}/promotions/${id}`)
			.then(successRequest)
			.catch(failedRequest);
	}

	function addComponent(promotionId, componentId, componentType) {
		return $http.post(`${AppConstants.apiUrl}/promotions/${promotionId}/attach`, {
			'promotionable_id': componentId,
			'promotionable_type': componentType
		})
			.then(successRequest)
			.catch(failedRequest);
	}

	function removeComponent(promotionId, componentId, componentType) {
		return $http.post(`${AppConstants.apiUrl}/promotions/${promotionId}/detach`, {
			'promotionable_id': componentId,
			'promotionable_type': componentType
		})
			.then(successRequest)
			.catch(failedRequest);
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		console.log(requestError);
		return requestError;
	}
}

export default PromotionsComponent;



/** WEBPACK FOOTER **
 ** ./client/components/promotion/promotion.service.js
 **/